<template>
  <div class="relative">
    <van-popup v-model="toggle" round position="bottom">
      <div class="p-2">
        <v-icon icon="ph:qr-code" class="text-2xl inline mr-1" @click="toggle = false" />
        Arahkan Kamera Ke QR
      </div>
      <QRComp
        v-if="toggle"
        @detect="
          (a) => {
            qr.code = a;
            toggle = false;
          }
        "
      />
    </van-popup>

    <van-cell-group inset :title="title || 'Scan QR Code'">
      <van-cell title="Pindai Kode QR" @click="() => (toggle = true)" is-link label="Tekan untuk memulai scanning">
        <template #icon>
          <v-icon icon="ph:qr-code" class="text-3xl my-auto ml-2 mr-4" />
        </template>
      </van-cell>
      <van-cell
        v-if="qr.code"
        title="Kode QR Terdeteksi"
        :label="locationData ? locationData.name : 'Tidak ada lokasi terdeteksi'"
      >
        <template #icon>
          <v-icon icon="ph:check-circle" class="text-2xl my-auto ml-2 mr-4 text-success" />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import { ImagePreview } from "vant";
  import QRComp from "../Inputs/QRComp.vue";
  import { fetchPointLocations, pointLocations } from "@/states/user";

  export default {
    components: {
      QRComp
    },
    props: {
      title: String
    },
    data() {
      return {
        toggle: false,
        pointLocations,
        qr: {
          code: null,
          Id: ""
        }
      };
    },
    mounted() {
      fetchPointLocations();
    },
    emits: ["selected"],
    watch: {
      // qr.code?
      "qr.code": {
        handler(val) {
          if (!val) return;
          this.$emit("selected", val);
        },
        immediate: true,
        deep: true
      }
    },
    computed: {
      locationData() {
        return this.pointLocations.data.find((x) => x.id === this.qr.code) || null;
      }
    },
    methods: {
      takePhoto(photo) {
        const url = URL.createObjectURL(photo);
        this.pictures.push(url);
      },
      openPreview() {
        ImagePreview({ images: [this.pictureUrl], closeable: true });
      }
    }
  };
</script>
